import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./moldesCapabilities.css"
import React, { useState, useEffect, useCallback } from 'react'
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import logoMoldesPT from "../../imagens/logos/logoMolds.png"
import logoMoldesEN from "../../imagens/logos/logoMoldsEn.png"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next";

const MoldesCapabilities = ({ moldesList }) => {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const { i18n } = useTranslation()
    const language = i18n.language

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => setOpenModal(false)

    const nextSlide = useCallback(() => {
        slideNumber + 1 === moldesList.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)
    }, [slideNumber, moldesList.length])

    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(moldesList.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, moldesList.length])

    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);

    return (
        <div>
            {/* Logo PT / EN */}
            <div>
                <img
                    className='img-custom-size img-fluid ms-2'
                    src={language === "en" ? logoMoldesEN : logoMoldesPT}
                    alt='logoMoldes'
                />
            </div>

            {/* Modal */}
            {openModal &&
                <div className="moldesSliderWrap">
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="moldesBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="moldesBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="moldesBtnClose" onClick={() => handleCloseModal()} />
                    <img className="moldesFullScreen" src={moldesList[slideNumber].img} alt="moldes" />
                </div>
            }

            {/* Gallery */}
            <div className="moldesGalleryWrap mx-2">
                {moldesList?.map((image, index) => (
                    <div
                        className="moldesSingle"
                        key={index}
                        onClick={() => handleOpenModal(index)}
                    >
                        <img src={image.img} alt="moldes" />
                    </div>
                ))}
            </div>

            {/* Back button PT / EN */}
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/ToolingAndManufacturing">
                    <button className="stampingToolButton">
                        {language === "en"
                            ? "Back to tooling design and manufacturing"
                            : "Voltar à fabricação de ferramental"}
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default MoldesCapabilities
